<template>
    <!--@formatter:off-->
    <li>
        <strong class="tit">{{$t('EnrolmentQuestionProgramGradeEditor_target')}}<em class="required">*</em></strong>
        <div class="cont">
            <span
                v-for="(grade, index) in select.grade.options"
                :key="grade.value"
                class="item"
            >
                <span class="chk_inp">
                    <input
                        type="checkbox"
                        :id="`grade-${questionIndex}-${programIndex}-${index}`"
                        :value="grade.value"
                        v-model="filters"
                    >
                    <label :for="`grade-${questionIndex}-${programIndex}-${index}`" class="lbl">{{grade.label}}</label>
                </span>
            </span>
        </div>
    </li>
    <!--@formatter:on-->
</template>

<script>
export default {
    name: "EnrolmentQuestionProgramGradeEditor",

    props: {
        questionIndex: {
            type: Number,
            required: true,
        },

        programIndex: {
            type: Number,
            required: true,
        },
    },

    computed: {
        ...createComputed('filters'),

        select() {
            return {
                grade: {
                    options: this.$store.state.enrolment.options.filterOptions.filters,
                },
            }
        },
    },

    methods: {
        getStorePath() {
            return `form.questions[${this.questionIndex}].programs[${this.programIndex}]`;
        },
    },
}

function createComputed(key) {
    return {
        [key]: {
            get() {
                return this.$store.getters['enrolment/getField'](`${this.getStorePath()}.${key}`);
            },
            set(newValue) {
                this.$store.commit('enrolment/updateField', {
                    path: `${this.getStorePath()}.${key}`,
                    value: newValue,
                });
            },
        },
    }
}
</script>

<style scoped>

</style>